export const API_HOST = process.env.REACT_APP_API_HOST;
export const WEB_HOST = process.env.REACT_APP_HOST;
export const SOCKET_HOST = process.env.REACT_APP_SOCKET_HOST;
export const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH;

export const KEEPER_HOST = process.env.REACT_APP_KEEPER_HOST;
export const CONVERSATION_MAKER_HOST = process.env.REACT_APP_CONVERSATION_MAKER_HOST;

export const NLU_CTX = process.env.REACT_APP_NLU_CTX;

export const DISABLE_BUGSNAG = process.env.REACT_APP_DISABLE_BUGSNAG === "true";
export const ENABLE_SLOT = process.env.REACT_APP_ENABLE_SLOT === "true";

export const ALT_DOMAIN_ID = 0;

export const QUERY_DEVTOOLS = process.env.REACT_APP_QUERY_DEVTOOLS === "true";
